import { FrontPluginSidebar } from './components/FrontPluginSidebar';

export const FrontPlugin = () => {
  return <FrontPluginSidebar />;
};
